import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import { useState } from 'react';
import EventEmitter from '../utils/eventEmitter';

export const loadJournals = async () => {
  try {
    let accounts = await Axois.get('journals')
    const responseData = await accounts.data;
    return responseData
  }catch (err) {
    console.log(err);
  }
};


export const loadJournalTypes = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('setups/journals')
        let journalTypes = await requests.data;
        return {...journalTypes, journal:{}};
      default: 
        let response = await Axois.get('journals/find/'+action)
        let responseData = await response.data;
        // console.log(responseData)
        return responseData;
    }
  }catch (err) {
    console.log(err);
  }
};

const useJournalAPI = () => {


  const create = async(data, toast) => {
    const { success, error } = toast;
    try {
      const response = await Axois.post('journals/', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('journal_created', data.seo)
    }catch(err) {
      error(err.message);
    }
  }

  const createEntry = async (data, toast) => {
    try {
      const response = await Axois.post('journals/entry/create');
      const responseData = await response.data;
      toast(responseData.message);
      // EventEmitter.dispatch('journal_updated', data)
    }catch(err) {
      console.log(err);
    }
  }


  const update = async (name, data, success) => {
    try {
      const response = await Axois.put('journals/'+name, data);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('updated_journal', seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { create, createEntry, update };
};



export default useJournalAPI;